import { AdvancedFiltersState } from '@/components/reserves/AdvancedFilters'

export interface QuickView {
  id: string
  name: string
  description: string
  icon: string
  filters: AdvancedFiltersState
}

export const QUICK_VIEWS: QuickView[] = [
  {
    id: 'contactar-hoy',
    name: 'Contactar Hoy',
    description: 'Arriben avui, no contactats i pagament pendent',
    icon: '🔥',
    filters: {
      dies_arribada: '1',
      contactat: false,
      estat_pagament: 'PENDENT',
    },
  },
  {
    id: 'checkins-hoy',
    name: 'Check-ins Hoy',
    description: 'Arribades confirmades per avui',
    icon: '📥',
    filters: {
      dies_arribada: '0',
    },
  },
  {
    id: 'pagos-pendientes',
    name: 'Pagos Pendientes',
    description: 'Totes les reserves amb pagament pendent',
    icon: '💰',
    filters: {
      estat_pagament: 'PENDENT',
    },
  },
  {
    id: 'proxima-semana',
    name: 'Pròxima Setmana',
    description: 'Arribades en els propers 7 dies',
    icon: '📅',
    filters: {
      dies_arribada: '7',
    },
  },
  {
    id: 'prioritarias',
    name: 'Prioritàries',
    description: 'Reserves marcades com a prioritàries',
    icon: '⭐',
    filters: {
      prioritat: true,
    },
  },
  {
    id: 'sin-contactar',
    name: 'Sense Contactar',
    description: 'Reserves que encara no han estat contactades',
    icon: '📞',
    filters: {
      contactat: false,
    },
  },
]
